// App
import React from 'react';
import styled from 'styled-components';

// Components
import HdpContentWrapper from 'app/shared/modules/hdp/HdpContentWrapper';

// Misc / utils
import { font } from 'app/shared/styles/_fontsize';

type Broker = {
  contactName: string;
  companyName: string;
  companyPhoneNumber?: string;
};

type BrokerInfoTopProps = {
  broker: Broker;
  isListingActive: boolean;
};

// Styled component
const BrokerText = styled.p`
  ${font.md};
`;

const areEqual = (prevProps: BrokerInfoTopProps, nextProps: BrokerInfoTopProps): boolean => {
  if (
    prevProps.broker.contactName === nextProps.broker.contactName &&
    prevProps.broker.companyName === nextProps.broker.companyName
  ) {
    return true;
  }

  return false;
};

const BrokerInfoTop = ({ broker, isListingActive }: BrokerInfoTopProps) => {
  return (
    <HdpContentWrapper header="Listing provided by" headerHtmlTag="h2" active>
      <address>
        <BrokerText>{broker.companyName}</BrokerText>
        <BrokerText>{broker.contactName}</BrokerText>
        {isListingActive && <BrokerText>{broker.companyPhoneNumber}</BrokerText>}
      </address>
    </HdpContentWrapper>
  );
};

export default React.memo(BrokerInfoTop, areEqual);
